import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { ROUTER_CONFIG } from '@core/configs';
import { MultipleSpinnerService, PermissionService } from '@core/services/common';

export const permissionResolver: ResolveFn<any> = async (): Promise<any> => {
  const router = inject(Router);
  const multipleSpinnerService = inject(MultipleSpinnerService);
  const permissionService = inject(PermissionService);

  try {
    multipleSpinnerService.show();
    return await permissionService.getUserPermissions();
  } catch (e) {
    console.error(e);
    return await router.navigate([ROUTER_CONFIG.notFound]);
  } finally {
    multipleSpinnerService.hide();
  }
};
